import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { buildEditorialReport } from '@/lib/editorial';

export default function Editorial() {
  const r = buildEditorialReport(new Date());
  return (
    <>
      <Helmet>
        <title>Editorial status report</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Header />
      <main className="container mx-auto px-4 py-10 max-w-4xl">
        <h1 className="text-3xl font-bold text-foreground">Editorial status report</h1>
        <p className="text-muted-foreground mt-2 text-sm">
          Generated in your browser from the catalogue as of today. Nothing here updates itself: flags mean a person needs to re-check a record. Cadence: prices/links weekly, availability and filters monthly, specifications quarterly.
        </p>
        <dl className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-6 text-sm">
          {Object.entries(r.counts).map(([k, v]) => (
            <div key={k} className="rounded-lg border border-border p-3"><dt className="text-muted-foreground">{k}</dt><dd className="text-2xl font-bold text-foreground">{v}</dd></div>
          ))}
        </dl>
        <div className="overflow-x-auto mt-8 rounded-lg border border-border">
          <table className="w-full text-sm">
            <thead className="bg-muted"><tr>
              <th scope="col" className="text-left p-3">Record</th><th scope="col" className="text-left p-3">Status</th><th scope="col" className="text-left p-3">Flags</th>
            </tr></thead>
            <tbody>
              {r.rows.map((row) => (
                <tr key={row.id} className="border-t border-border align-top">
                  <td className="p-3"><Link to={`/products/${row.id}`} className="text-primary underline">{row.name}</Link></td>
                  <td className="p-3">{row.state}</td>
                  <td className="p-3">{row.flags.length ? <ul className="list-disc pl-4 space-y-0.5">{row.flags.map((f) => <li key={f}>{f}</li>)}</ul> : <span className="text-muted-foreground">none</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
      <Footer />
    </>
  );
}
